import { createSelector } from 'reselect';
import { reportTypes } from '../utils/reports';
import { FIELDS_AVAILABILITY_ENABLED_REPORT_TYPES } from '../fieldsAvailability/consts';

export const normalizeAccountTypeName = accountTypeName => (accountTypeName || '').toLowerCase().replace(/ /g, '_');

export const ACCOUNT_AD_NETWORK = 'ad_network';
export const AGENCY_ACCOUNT = 'agency_account';

export const getIsBlocked = state => {
    return state.user.data?.should_block_app;
};

export const getIsOrgAdmin = state => {
    return state.user.data?.is_org_admin;
};

export const getAdminModeEnabled = state => {
    return state.user.adminMode;
};

export const getUserData = state => {
    return state.user.data;
};

export const getFieldsAvailabilityEnabled = (state, type) => {
    return (
        FIELDS_AVAILABILITY_ENABLED_REPORT_TYPES.includes(type) &&
        (getUserData(state).is_fields_availability_enable || state.user.adminMode)
    );
};

export const isAdvanceModeVisible = type => {
    return type === reportTypes.creativeExplore;
};

export const getIsUserAdmin = state => {
    return getUserData(state).is_admin;
};

export const getUserFeatureFlags = state => {
    return getUserData(state).feature_flags;
};

export const getChangePasswordDialog = state => {
    return state.user.changePasswordDialog;
};

export const isUserTiEnabled = state => {
    return getUserData(state).is_ti_enabled;
};

export const showPivotCharts = state => {
    return getUserData(state).show_pivot_charts;
};

export const getUserPermissionDimensions = state => {
    return getUserData(state).permission_dimensions || [];
};

export const isShelfReporting = (state, reportType) => {
    return reportType === reportTypes.mainReport && getUserData(state).is_shelf_reporting;
};

export const getPermissionKeys = state => {
    return getUserData(state).permission_keys;
};

export const isUserAdNetwork = createSelector([getUserData], userData => {
    const accountType = normalizeAccountTypeName(userData.account_type_name);
    return accountType === ACCOUNT_AD_NETWORK;
});

export const getIsAgency = createSelector([getUserData], userData => {
    return normalizeAccountTypeName(userData.account_type_name) === AGENCY_ACCOUNT;
});

// The viewing org's own agency id (set when the account is an agency; null otherwise).
export const getAgencyId = createSelector([getUserData], userData => userData.agency_id || null);

export const shouldShowTrialStatusPanel = state => {
    return state.user.showTrialStatusPanel;
};

export const getTrialRealDaysLeft = state => {
    return state.user.trialRealDaysLeft;
};

export const getIsTrialUser = state => {
    return !!getUserData(state).trial;
};

export const getOrganizationTier = state => {
    return getUserData(state).organization_tier;
};

export const getIsPayingCustomer = state => {
    return getUserData(state).is_paying_customer;
};

export const getOrganizationIsWeb = state => {
    return getUserData(state).is_web;
};

export const getOrganizationAvailablePlatforms = state => {
    return getUserData(state).available_platforms;
};

export const getOrganizationLogo = state => {
    return getUserData(state).company_logo;
};

export const getUserCurrency = state => {
    return getUserData(state).currency;
};

export const getDisplayUnenriched = state => {
    const userData = getUserData(state);
    return userData.display_unenriched || userData.display_unenriched_by_default;
};

export const getIsAlertPaused = state => {
    return getUserData(state).is_paused_alerts;
};
